import { Observable } from 'rxjs';
import { AdvisorListResponse } from '../models/advisor-response.model';
import { AdvisorListResponseObject } from '../models/advisor-response-object.model';
import { PershingError } from '../models/pershing-error.model';

export abstract class IOrgContextService {
    advisorlistResponse$: Observable<AdvisorListResponse>;
    responseObject$: Observable<AdvisorListResponseObject>;
    error$: Observable<PershingError>;

    abstract loadAdvisorList(businessParty?: string): void;
    abstract setError(errorMessage: string, errorCode?: string): void;
    abstract clearError(): void;
}
